import { adminApi } from '@/shared/api/adminApi';

export interface AdminLoginPayload {
  username: string;
  password: string;
}

export function bootstrapAdmin(payload: {
  username: string;
  password: string;
  name: string;
  email?: string;
}, opts?: { bootstrapToken?: string }) {
  return adminApi().post('/admin/auth/bootstrap', payload, {
    headers: opts?.bootstrapToken ? { 'x-admin-bootstrap-token': opts.bootstrapToken } : {},
  });
}

export function loginAdmin(payload: AdminLoginPayload) {
  return adminApi().post('/admin/auth/login', payload);
}

export function logoutAdmin() {
  return adminApi().post('/admin/auth/logout', {});
}

export function refreshAdmin() {
  return adminApi().post('/admin/auth/refresh', {});
}

export function getAdminMe() {
  return adminApi().get('/admin/auth/me');
}

export function pingAdmin() {
  return adminApi().get('/admin/ping');
}


